var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "#b5b5b5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81416 1.15239L5.4275 5.80109C5.37123 5.86369 5.30242 5.91375 5.22554 5.94802C5.14866 5.98229 5.06542 6 4.98125 6C4.89708 6 4.81384 5.98229 4.73696 5.94802C4.66008 5.91375 4.59127 5.86369 4.535 5.80109L0.185837 1.15239C0.0767859 1.01615 0.0119494 0.849858 3.67315e-06 0.675767C-0.000563098 0.50388 0.0644792 0.338253 0.181861 0.212676C0.299243 0.0870984 0.46012 0.0110338 0.63167 0L9.36833 0C9.53988 0.0110338 9.70076 0.0870984 9.81814 0.212676C9.93552 0.338253 10.0006 0.50388 10 0.675767C9.98805 0.849858 9.92321 1.01615 9.81416 1.15239Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSolid);
export default __webpack_public_path__ + "static/media/chevron-solid.a45ada7724c5c36733ec2bf357b8792c.svg";
export { ForwardRef as ReactComponent };